module.exports = __webpack_public_path__ + "static/media/22.be91ca6f.jpeg";